import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSlider2 from "../components/Slider/CardSlider2";
import RoiCTA from "../components/CTA/RoiCTA";
import FeaturedContent from "../components/Featured/FeaturedContent";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import { useModal } from "../context/ModalContext";
import FAQs from "../components/FAQ/FAQs";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";

const faqData = [
  {
    question: "What is the Happy Driver Programme?",
    answer:
      "The Happy Driver Programme is a customisable driver training initiative by Shoora that promotes road safety, rewards safe driving behaviors, and offers tools and resources for driver well-being and skill development.",
  },
  {
    question: "How does the reward system work for drivers?",
    answer:
      "Drivers earn HDScore points based on their safe driving performance and real-time corrections using CabIn Alerts. These scores recognize and incentivise positive driving habits, fostering a culture of safety.",
  },
  {
    question: "What areas of driver health and well-being are addressed?",
    answer:
      "The program covers regular health screenings, mental health workshops, nutrition and fitness guidance, and stress management to enhance drivers’ overall well-being and productivity.",
  },
  {
    question: "What topics are included in road safety education?",
    answer:
      "Drivers receive training on defensive driving, speed management, hazard awareness, and road etiquette through periodic workshops and e-learning modules to improve road safety practices.",
  },
  {
    question: "Does Shoora offer in-person coaching for drivers?",
    answer:
      "Yes, Shoora collaborates with experts to provide in-person coaching on alcohol recovery, road safety, and mental health, ensuring a hands-on approach to driver engagement and skill enhancement.",
  },
  {
    question: "What is the Happy Driver Programme's impact on my fleet?",
    answer:
      "The Happy Driver Programme can significantly improve driver safety and productivity by reducing the number of accidents, improving overall driver satisfaction, and fostering a culture of safety within your fleet.",
  },
];

// The Happy Driver Programme is a customisable driver training initiative by Shoora that promotes road safety, rewards safe driving behaviors, and offers tools and resources for driver well-being and skill development.
// How does the reward system work for drivers?
// Drivers earn HDScore points based on their safe driving performance and real-time corrections using CabIn Alerts. These scores recognize and incentivise positive driving habits, fostering a culture of safety.
// What areas of driver health and well-being are addressed?
// The program covers regular health screenings, mental health workshops, nutrition and fitness guidance, and stress management to enhance drivers’ overall well-being and productivity.
// What topics are included in road safety education?
// Drivers receive training on defensive driving, speed management, hazard awareness, and road etiquette through periodic workshops and e-learning modules to improve road safety practices.
// Does Shoora offer in-person coaching for drivers?
// Yes, Shoora collaborates with experts to provide in-person coaching on alcohol recovery, road safety, and mental health, ensuring a hands-on approach to driver engagement and skill enhancement.

const happyDriverFeatures = [
  {
    id: 1,
    category: "Feature",
    title: "Reward Safe Driving ",
    description:
      "HDScore tracks driver performance over time, rewarding safe driving behaviour and reducing the number of alerts generated. Drivers are also rewarded for making real-time corrections when alerted by CabIn Alerts.",
    image: "/images/features/16.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 2,
    category: "Feature",
    title: "Create a culture of safety",
    description:
      "Promote safe driving by rewarding drivers with performance scores that highlight their achievements, fostering skill development and recognizing their commitment to safety and continuous improvement.",
    image: "/images/features/17.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 3,
    category: "Feature",
    title: "In-person Driver engagement",
    description:
      "Shoora partners with experts to deliver in-person driver coaching, covering essential areas like alcohol recovery, road safety, and mental well-being",
    image: "/images/features/18.png",
    // link: "#",
    // linkText: "Read more",
  },
];

const HappyDriverProgramme = () => {
  const { openModal } = useModal();
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <Page
  title="Happy Driver Programme | Shoora"
  description="The Happy Driver Programme by Shoora offers customisable driver training, focusing on road safety, health, and well-being, while rewarding safe driving behavior and promoting positive habits."
  keywords="Happy Driver Programme, driver training, road safety, health and well-being, driver rewards, safe driving, driver coaching, mental health, nutrition, fitness"
  structuredData={{
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Happy Driver Programme",
    "image": "/images/hero/happy-driver-2.webp",
    "description": "Shoora's Happy Driver Programme offers a comprehensive and customisable training initiative focused on promoting safe driving behaviors, driver health, and well-being, while offering rewards for positive driving actions.",
    "provider": {
      "@type": "Organization",
      "name": "Shoora",
      "logo": "/images/logo-shoora.svg",
      "sameAs": "https://www.shoora.com"
    },
    "offers": {
      "@type": "Offer",
      "url": "#enroll-now",
      "priceCurrency": "USD",
      "price": "Available upon request",
      "priceValidUntil": "2025-12-31",
      "availability": "https://schema.org/InStock",
      "eligibleRegion": {
        "@type": "Place",
        "name": "Global"
      }
    },
    "mainEntityOfPage": "https://www.shoora.com/happy-driver-programme",
    "serviceType": "Driver Safety and Wellness Training",
    "audience": {
      "@type": "Audience",
      "audienceType": "Fleet Owners, Fleet Managers"
    }
  }}
>
      <div
        className="about-hero w-100"
        // style={{backgroundImage: "url(images/about/bg2.webp)"}}
      >
        <img
          src="/images/hero/happy-driver-2.webp"
          alt=""
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6 pe-lg-5">
            <p className="fs-6 text-accent mb-0 mt-5">Become a part of</p>
            <h1 className="text-white fw-bold mb-4 display-4">
              HAPPY DRIVER <i className="fw-light">PROGRAMME</i>
            </h1>
            <p className="fs-6 text-white mb-5 pe-5">
              {" "}
              Highly customisable e-modules to train drivers for safety. Enhance
              training effectiveness using powerful tools and reward points to
              promote safer driving and help drivers reinforce positive driving
              behaviours.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-dark rounded-5" onClick={openModal}>
                Enroll Now
              </button>
              <Link className="ms-3 btn btn-link text-white fw-bold text-decoration-none">
                Get a Demo
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation Bar */}
      <div className="container-fluid bg-black sticky-top d-none d-lg-block">
        <div className="container nav-links">
          <ul className="navigation-group">
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("overview")}
                className="navigation-item-link btn btn-link text-white"
              >
                Overview
              </button>
            </li>

            <li className="navigation-item">
              <button
                onClick={() => handleScroll("training-areas")}
                className="navigation-item-link btn btn-link text-white"
              >
                Benefits
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("testimonials")}
                className="navigation-item-link btn btn-link text-white"
              >
                Testimonials
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("faqs")}
                className="navigation-item-link btn btn-link text-white"
              >
                FAQs
              </button>
            </li>
          </ul>
        </div>
      </div>

      <section id="overview" className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col col-12 col-lg-10 text-center">
            <h6 className="fs-bold text-accent">Happy Driver Programme Need</h6>
            <h1 className="mb-4">
              World class modules to train your drivers to make operations more
              efficient and happy
            </h1>
            {/* <p className='mb-5'>
                            Instantly access and download accident videos and share crucial evidence with authorities to clear your drivers' name, leverage this to cut accident-related costs.

                        </p> */}
          </div>
          {/* <div className="col">
                        <img src="/images/products/cabinalert1.png" alt="" className='w-100 pt-5 p-lg-0 pe-0' />

                    </div> */}
        </div>
      </section>

      <div className="my-5">
        <CardSlider2 data={happyDriverFeatures} />
      </div>

      <section id="training-areas">
        <CardContainer
          heading="Key Training Areas"
          desc="Get to know us through our associates and the impact we make together."
        >
          <Card
            // category="Safety"
            bgColor="#f4f4f4"
            type="primary"
            headingColor="#0d004a"
            heading="Health and Well-being"
            desc="Regular health check-ups and screenings for drivers to detect and address common health issues, including hypertension, diabetes, and fatigue"
            imgsrc="/images/benefits/12.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Mental Health"
            desc="We offer mental health programs and stress management workshops, addressing the psychological toll of long hours on the road."
            imgsrc="/images/benefits/13.png"
          />
          <Card
            // category="Coaching insights"
            type="primary"
            heading="Nutrition and Fitness"
            desc="Information or resources on healthy eating and fitness routines that can be adapted to a driver’s lifestyle"
            imgsrc="/images/benefits/14.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Road Safety Education"
            desc="Conducting periodic safety workshops and e-learning modules focused on defensive driving, speed limits, hazard awareness, and road etiquette."
            imgsrc="/images/benefits/15.png"
          />
          <Card
            // category="Coaching insights"
            type="primary"
            heading="Alcohol and Tobacco De-addiction Drives"
            desc="Generating awareness initiatives about the dangers of alcohol and tobacco use while driving and its impact on health and safety."
            imgsrc="/images/benefits/16.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            type="img"
            heading="Join Us"
            desc="Transform your ordinary fleet drivers into well trained drivers for better road safety assurance."
            imgsrc="/images/benefits/17.png"
            linkText="Enroll Now"
            // link="/careers"
          />
        </CardContainer>
      </section>

      <section id="testimonials" className="testimonials-section section">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      <section id="faqs">
        <FAQs
          data={faqData}
          title="Your questions about HappyDriver Programme, answered."
        />
      </section>
    </Page>
  );
};

export default HappyDriverProgramme;
